import { isToggleActiveDto } from '@interfaces/featureToggle';
import { fetcher } from '@utils/fetcher';

const API_URL = '/api/featureToggle';

// Vários `ProductCard`s montam ao mesmo tempo e cada um chama `useFeatureToggleAccess` várias vezes para os
// mesmos toggles — que respondem igual para todos, pois dependem só de `platformUserId`. Sem isso, N
// comunidades geram 3N requisições idênticas em paralelo. É deduplicação de chamadas em voo, não cache de
// resultado: a entrada some assim que a promise resolve ou rejeita, então nunca serve uma resposta velha.
const inFlightRequests = new Map<string, Promise<{ success: boolean }>>();

export const isToggleActive = async (
  dto: isToggleActiveDto,
): Promise<{ success: boolean }> => {
  const key = JSON.stringify(dto);

  const inFlight = inFlightRequests.get(key);
  if (inFlight) return inFlight;

  const request = fetcher<{ success: boolean }>(`${API_URL}/isActive`, {
    method: 'POST',
    body: dto,
  }).finally(() => {
    inFlightRequests.delete(key);
  });

  inFlightRequests.set(key, request);
  return request;
};
